import { render, staticRenderFns } from "./BibliotecaVirtual.vue?vue&type=template&id=9d1873c4&scoped=true"
import script from "./BibliotecaVirtual.vue?vue&type=script&lang=js"
export * from "./BibliotecaVirtual.vue?vue&type=script&lang=js"
import style0 from "./BibliotecaVirtual.vue?vue&type=style&index=0&id=9d1873c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1873c4",
  null
  
)

export default component.exports